export default "__VITE_ASSET__DqDAiutq__"